// extracted by mini-css-extract-plugin
export default {"checkout_summary":"hw","checkout_summary_wrapper":"iw","summary_items":"jw","line_items_wrapper":"kw","separator":"lw","order_summary":"mw","line_item":"nw","order__summary_item_title":"ow","recurringdis":"pw","note":"qw","carbon_emission":"rw","unlock_savings":"sw","member_perk":"tw","info":"uw","no_items":"vw","promo":"ww","order_summary_mobile":"xw","open_summary_mobile":"yw","fixed_bottom_info":"zw","open_info":"Aw","text":"Bw","open_summary":"Cw"};
    if(module.hot) {
      // 1737143654486
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  